import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "port-list-tip-bar__left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  t: "1778317254379",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "9443",
  width: "17",
  height: "17"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M512 981.333333C253.866667 981.333333 42.666667 770.133333 42.666667 512S253.866667 42.666667 512 42.666667s469.333333 211.2 469.333333 469.333333-211.2 469.333333-469.333333 469.333333z m0-844.8c-206.506667 0-375.466667 168.96-375.466667 375.466667 0 206.506667 168.96 375.466667 375.466667 375.466667 206.506667 0 375.466667-168.96 375.466667-375.466667 0-206.506667-168.96-375.466667-375.466667-375.466667z",
    fill: "var(--el-color-primary)",
    "p-id": "9444"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M512 796.714667a46.08 46.08 0 0 1-46.933333-46.933334v-269.056c0-26.624 20.352-46.933333 46.933333-46.933333 26.581333 0 46.933333 20.309333 46.933333 46.933333v269.056c0 26.624-20.352 46.933333-46.933333 46.933334zM512 364.928a46.08 46.08 0 0 1-46.933333-46.933333V274.218667c0-26.624 20.352-46.933333 46.933333-46.933334 26.581333 0 46.933333 20.309333 46.933333 46.933334v43.776c0 26.624-21.888 46.933333-46.933333 46.933333z",
    fill: "var(--el-color-primary)",
    "p-id": "9445"
  })
], -1)
const _hoisted_3 = { class: "port-list-tip-bar__summary" }
const _hoisted_4 = { class: "port-list-tip-bar__actions" }

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'cmtable-selection-tip-bar',
  props: {
    barHeight: { default: 34 },
    actionAlign: { default: 'left' }
  },
  setup(__props: any) {

const props = __props

const barStyle = computed(() => ({
  '--cmtable-selection-tip-bar-height': `${props.barHeight}px`,
}))

const actionsClassName = computed(() => {
  return props.actionAlign === 'right'
    ? 'cmtable-selection-tip-bar--actions-right'
    : 'cmtable-selection-tip-bar--actions-left'
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, {
    class: "is-plain port-list-tip-row",
    align: "center"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, {
        span: 24,
        class: _normalizeClass(["primary-bg port-list-tip-bar-col cmtable-selection-tip-bar", actionsClassName.value]),
        style: _normalizeStyle(barStyle.value)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "summary")
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "actions")
          ])
        ]),
        _: 3
      }, 8, ["class", "style"])
    ]),
    _: 3
  }))
}
}

})